import { Link } from 'react-router-dom'

import { useAppContext } from '@/App.context'

const ButtonLink = ({ to, children }: any) => {
  const { whiteLabel } = useAppContext()

  return (
    <Link to={to} className={`button wl-${whiteLabel}`}>
      {children}
    </Link>
  )
}

export default ButtonLink
